import React from "react";
import { View, Text, TouchableOpacity } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import Sidebar from "react-sidebar";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Phone from "../utils/Phone";
import { closeMenu, openMenu, logout, resetStore } from "../redux/actions/menu";
import { RepositStyles } from "../utils/styles";
import { accessTokenItemName } from "../redux/actions/user";
import storage from "../utils/storage";
import { browserHistory } from "react-router";

const Home = <Icon name="home" size={20} />;
const Logout = <Icon name="sign-out" size={20} />;

const mapStateToProps = (state) => ({
  menu: state.menu,
  box: state.box,
});

const mapDispatchToProps = (dispatch) => {
  return {
    menuActions: bindActionCreators(
      { closeMenu, openMenu, logout, resetStore },
      dispatch
    ),
  };
};

class MenuWrapper extends React.Component {
  fullLogout = () => {
    storage
      .remove({ key: accessTokenItemName })
      .then((ret) => {
        browserHistory.push("/");
        this.props.menuActions.logout();
      })
      .catch(() => {
        browserHistory.push("/");
        this.props.menuActions.logout();
      });
  };

  goHomeWeb = () => {
    browserHistory.push("/");
    this.props.menuActions.resetStore();
  };
  render() {
    return (
      <Sidebar
        sidebar={
          <RepositMenu
            goHome={this.goHomeWeb}
            closeMenu={this.props.menuActions.closeMenu}
            isOpen={this.props.menu.menuOpen}
            logout={this.fullLogout}
            serialNum={this.props.box.serialNumber}
          />
        }
        open={this.props.menu.menuOpen}
        onSetOpen={(isOpen) => {
          isOpen
            ? this.props.menuActions.openMenu()
            : this.props.menuActions.closeMenu();
        }}
        pullRight={true}
      >
        {this.props.children}
      </Sidebar>
    );
  }
}

const RepositMenu = ({ isOpen, goHome, logout, serialNum }) => {
  return (
    <View style={{ flex: 1, backgroundColor: "white", height: "100vh" }}>
      <View style={{ flex: 1 }}>
        <View style={{ flex: 1, marginTop: 60 }}>
          <View
            style={{
              borderBottomColor: "#E2E2E2",
              borderBottomWidth: 1,
              borderTopColor: "#E2E2E2",
              borderTopWidth: 1,
            }}
          >
            <TouchableOpacity onPress={() => goHome()}>
              <Text
                style={{
                  ...RepositStyles.paragraphText,
                  marginVertical: 20,
                  marginHorizontal: 10,
                }}
              >
                {Home} Home
              </Text>
            </TouchableOpacity>
          </View>
          <View style={{ borderBottomColor: "#E2E2E2", borderBottomWidth: 1 }}>
            <TouchableOpacity onPress={() => logout()}>
              <Text
                style={{
                  ...RepositStyles.paragraphText,
                  marginVertical: 20,
                  marginHorizontal: 10,
                }}
              >
                {Logout} Logout
              </Text>
            </TouchableOpacity>
          </View>
          {serialNum ? (
            <View>
              <Text
                style={{
                  ...RepositStyles.paragraphText,
                  marginVertical: 20,
                  marginHorizontal: 10,
                }}
              >
                Currently installing:{" "}
                <Text style={{ fontWeight: "bold" }}>{serialNum}</Text>
              </Text>
            </View>
          ) : null}
        </View>
        <View style={{ flex: 1, justifyContent: "flex-end" }}>
          <Text
            style={{
              ...RepositStyles.paragraphText,
              fontSize: 18,
              marginBottom: 40,
              marginHorizontal: 10,
            }}
          >
            Problems? <Phone>Call Reposit on</Phone>
          </Text>
        </View>
      </View>
    </View>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuWrapper);



// WEBPACK FOOTER //
// ./src/components/RepositMenu.web.js